<template>
    <section class="home-container">
        <MasterPage title="角色权限">
            <div slot="title-icon">
                <Icon type="md-settings" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="角色名称：">
                            <Input v-model="name" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="角色状态：">
                            <Select v-model="isDeleted" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="false">启用</Option>
                                <Option value="true" >禁用</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindPermissionRole">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="infoModel" title="角色已有权限" >
            <Form :label-width="80">
                <Table stripe max-height="350" :columns="columnsInfo" :data="dataInfo"></Table>
            </Form>
        </Modal>
        <Modal v-model="addModel" title="新增角色" @on-cancel="cancelPermissionRole">
            <Form :label-width="80">
                <FormItem label="角色名称：">
                    <Input v-model="permissionRole.name" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
                <FormItem label="角色描述：">
                    <Input v-model="permissionRole.description" autocomplete="new-password" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelPermissionRole">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addPermissionRole">确定</Button>
            </div>
        </Modal>
        <Modal v-model="bindModel" width="692" title="绑定角色权限" @on-cancel="cancelPermissionRole">
            <Form :label-width="80">
                <Transfer :data="permissionAllList" :list-style="style" :target-keys="permissionKeys" @on-change="transferChange"></Transfer>
            </Form>
            <p style="color: #c3c3c3;text-align: center;padding-top: 15px">绑定角色权限后，请重新登录，便于权限生效</p>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelPermissionRole">取消</Button>
                <Button type="primary" size="large" :loading="bindLoading" @click="bindPermissionRole">确定</Button>
            </div>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                style:{
                    width:'300px',
                    height:'350px',
                },
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '角色名称',
                        align: 'center',
                        key: 'name',
                    },
                    {
                        title: '角色描述',
                        align: 'center',
                        key: 'description',
                    },
                    {
                        title: '角色状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('span', '已禁用')
                            }else{
                                return h('span', '已启用')
                            }
                        }
                    },
                    {
                        title: '账户操作',
                        minWidth: 300,
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].isDeleted){
                                return h('div',[
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            icon:'ios-list-box',
                                        },
                                        style: {
                                            margin: '1px 5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.findPermissionRole_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '查看权限'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-unlock',
                                        },
                                        style: {
                                            margin: '1px 5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.reusePermissionRole_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '启用')
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            icon:'ios-list-box',
                                        },
                                        style: {
                                            margin: '1px 5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.findPermissionRole_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '查看权限'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            icon:'md-create',
                                        },
                                        style: {
                                            margin: '1px 5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.bindPermissionRole_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '权限绑定'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                        },
                                        style: {
                                            margin: '1px 5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deletePermissionRole_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '禁用')
                                ]);
                            }
                        }
                    }
                ],
                dataList: [],
                tableLoading: false,
                permissionAllList:[],
                permissionKeys:[],
                permissionRoleId:'',
                infoModel:false,
                columnsInfo:[
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '权限',
                        align: 'center',
                        key: 'description',
                    }
                ],
                dataInfo:[],
                addModel:false,
                addLoading:false,
                bindModel:false,
                bindLoading:false,
                name:'',
                isDeleted:'false',
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                permissionRole:{
                    name:'',
                    description:'',
                }
            }
        },
        created(){
            this.pageFindPermissionRole()
            this.findAllPermission()
        },
        methods:{
            pageChange(value){
                this.pageNum = value
                this.pageFindPermissionRole()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindPermissionRole()
            },
            transferChange (newTargetKeys) {
                this.permissionKeys = newTargetKeys;
            },
            findAllPermission(){
                this.$http.post('permission/list',{
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.permissionAllList = msg.data.list.map((item)=>{return {key:item.id,label:item.description}})
                    }else {
                        this.$Notice.error({title:'角色权限查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindPermissionRole(){
                this.$Message.loading( '正在加载中。。。');
                this.tableLoading = true
                this.$http.post('permission/roleList',{
                    name:this.name,
                    isDeleted:this.isDeleted,
                    pageSize:this.pageSize,
                    pageNum:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'角色权限查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            findPermissionRole_modal(role){
                if (role.permissionList.length<=0){
                    return this.$Message.warning('暂无权限，请先绑定权限');
                }
                this.dataInfo = role.permissionList
                this.infoModel = true
            },
            addPermissionRole(){
                if (this.permissionRole.name.length <= 0){
                    return this.$Message.warning('请输入角色名称');
                }
                if (this.permissionRole.description.length <= 0){
                    return this.$Message.warning('请输入角色描述');
                }
                this.addLoading = true
                this.$http.post('permission/addRole',{
                    code:this.permissionRole.name,
                    description:this.permissionRole.description,
                }).then(function (res) {
                    this.cancelPermissionRole()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '角色新增成功'});
                        this.pageFindPermissionRole()
                    }else {
                        this.$Notice.error({title:'角色新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelPermissionRole()
                    this.myError(res.body)
                })
            },
            bindPermissionRole_modal(role){
                if (this.permissionAllList.length <= 0 ) {
                    this.findAllPermission()
                }
                this.permissionRoleId = role.id
                this.permissionKeys = role.permissionList.map((item) => {return item.id})
                this.bindModel = true
            },
            bindPermissionRole(){
                this.bindLoading = true
                this.$http.post('permission/bindRolePermission',{
                    roleId:this.permissionRoleId,
                    permissionIdList:this.permissionKeys.sort(sortNumbers).join(','),
                }).then(function (res) {
                    this.cancelPermissionRole()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '角色绑定权限成功'});
                        this.pageFindPermissionRole()
                    }else {
                        this.$Notice.error({title:'角色绑定权限失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelPermissionRole()
                    this.myError(res.body)
                })
            },
            cancelPermissionRole(){
                this.addModel = this.addLoading = this.bindModel = this.bindLoading = false
                this.permissionRole.name = this.permissionRole.description = ''
            },
            deletePermissionRole_modal(role){
                this.$Modal.confirm({
                    title: '确认禁用角色“'+role.name + '”',
                    loading:true,
                    onOk: () => {
                        this.deletePermissionRole(role);
                    }
                });
            },
            deletePermissionRole(role){
                this.$http.post('permission/deleteRole',{
                    id:role.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '角色禁用成功'});
                        this.pageFindPermissionRole()
                    }else {
                        this.$Notice.error({title:'角色禁用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            reusePermissionRole_modal(role){
                this.$Modal.confirm({
                    title: '确认启用角色“'+role.name + '”',
                    loading:true,
                    onOk: () => {
                        this.reusePermissionRole(role);
                    }
                });
            },
            reusePermissionRole(role){
                this.$http.post('permission/reuseRole',{
                    id:role.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '角色启用成功'});
                        this.pageFindPermissionRole()
                    }else {
                        this.$Notice.error({title:'角色启用失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
    function sortNumbers(a,b){
        return a-b;
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>
